import { Tournament } from "@portal-frontend-ssr/blast-api";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { ClientOnly } from "remix-utils/client-only";

export const Header = ({ tournament }: { tournament: Tournament }) => {
  const tournamentStartDate = tournament?.startDate ? DateTime.fromISO(tournament?.startDate) : null;
  const tournamentEndDate = tournament?.endDate ? DateTime.fromISO(tournament.endDate) : null;

  const isEventInSameMonth = useMemo(() => {
    if (!tournamentStartDate || !tournamentEndDate) return false;

    if (tournamentStartDate.year === tournamentEndDate.year && tournamentStartDate.month === tournamentEndDate.month) {
      return true;
    } else {
      return false;
    }
  }, [tournamentStartDate, tournamentEndDate]);

  if (!tournament) {
    return null;
  }

  return (
    <>
      <h1 className="font-style-heading-h1">{tournament?.name}</h1>
      <div className="flex flex-wrap items-center gap-3 font-style-body-b3">
        <ClientOnly fallback={<div className="h-3 w-16 animate-pulse rounded-full bg-background-80" />}>
          {() => (
            <time>
              {tournamentStartDate && tournamentStartDate.toFormat("LLL dd")}
              {tournamentEndDate && " - "}
              {tournamentEndDate &&
                (isEventInSameMonth ? tournamentEndDate.toFormat("dd") : tournamentEndDate.toFormat("LLL dd"))}
            </time>
          )}
        </ClientOnly>
        {tournament.prizePool && (
          <>
            <div className="size-1 rounded-full bg-white">&nbsp;</div>
            <span>{tournament.prizePool}</span>
          </>
        )}
        {tournament.numberOfTeams && (
          <>
            <div className="size-1 rounded-full bg-white">&nbsp;</div>
            <span>{tournament.numberOfTeams} teams</span>
          </>
        )}
        {tournament.location && (
          <>
            <div className="size-1 rounded-full bg-white">&nbsp;</div>
            <span>{tournament.location}</span>
          </>
        )}
      </div>
      {tournament.description && <span className="font-style-body-b3">{tournament.description}</span>}
      {tournament.metadata?.headerCta && (
        <a href={tournament.metadata.headerCta.url} target="_blank" rel="noreferrer" className="button-tertiary w-fit">
          {tournament.metadata.headerCta.text}
        </a>
      )}
    </>
  );
};
